export default __webpack_public_path__ + "static/media/plain-sticker-h.d87e1ffa.png";